module.exports = __webpack_public_path__ + "img/viber.15001cf9.svg";